import type { Activity, ActivityCategory } from "../types/cafe";

export const activityCategories: ("Semua" | ActivityCategory)[] = [
  "Semua",
  "Luar Ruang",
  "Kerja",
  "Komunitas",
  "Workshop",
];

export const activities: Activity[] = [
  {
    id: "cycling-pitstop",
    title: "Weekend Cycling Pitstop",
    category: "Luar Ruang",
    description:
      "Mampir setelah gowes pagi. Parkir sepeda aman, stasiun isi ulang air, dan es kopi susu siap di meja kasir.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/d47e6631-95ad-4b56-bb23-e98f8f024be7.jpg",
    schedule: "Sabtu & Minggu · 07.00–10.00",
    price: 45000,
    priceNote: "termasuk 1 minuman",
    spotsLeft: 12,
    outletIds: ["scbd", "fatmawati"],
  },
  {
    id: "wfh-pass",
    title: "WFH Cozy Corner Pass",
    category: "Kerja",
    description:
      "Kursi khusus dekat jendela dengan Wi‑Fi cepat, colokan listrik di dekatmu, dan dua minuman untuk menemani kerja.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/b3e31cfb-9839-439d-9017-3cf96b117581.jpg",
    schedule: "Senin–Jumat · 08.00–17.00",
    price: 85000,
    priceNote: "per hari",
    spotsLeft: 6,
    outletIds: ["cikajang", "tebet", "fatmawati"],
  },
  {
    id: "board-game-night",
    title: "Community Board Game Night",
    category: "Komunitas",
    description:
      "Lebih dari 50 board game, host yang paham aturannya, dan meja penuh teman baru. Datang sendiri atau bareng geng.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/d2716479-5b16-4668-935c-0e2700ed35c9.jpg",
    schedule: "Setiap Jumat · 18.00–21.00",
    price: 60000,
    priceNote: "termasuk snack platter",
    spotsLeft: 9,
    outletIds: ["tebet", "cikajang"],
  },
  {
    id: "garden-workshop",
    title: "Aesthetic Garden Workshop",
    category: "Workshop",
    description:
      "Rangkai terrarium mini bersama tim taman kami, lalu bawa pulang. Semua bahan dan satu minuman sudah termasuk.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/b1814aea-d192-4a76-8cba-da01072db293.jpg",
    schedule: "Setiap Minggu · 14.00–16.30",
    price: 175000,
    priceNote: "termasuk bahan",
    spotsLeft: 4,
    outletIds: ["scbd"],
  },
  {
    id: "manual-brew-class",
    title: "Manual Brew Mini Class",
    category: "Workshop",
    description:
      "Belajar seduh V60 bersama head barista kami menggunakan Arabika single origin dari Gayo dan Kintamani.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/5f226b86-94dd-4b01-aec1-9d0e211eaf78.jpg",
    schedule: "Setiap Sabtu · 10.00–12.00",
    price: 150000,
    priceNote: "bonus biji kopi",
    spotsLeft: 8,
    outletIds: ["cikajang", "scbd"],
  },
  {
    id: "sunset-sketch-walk",
    title: "Sunset Sketch Walk",
    category: "Luar Ruang",
    description:
      "Jalan santai keliling SCBD sambil menggambar, lalu kembali ke kafe untuk ngopi di waktu senja.",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/d430f4d2-be8a-4d71-85c5-54b48ff120a2.jpg",
    schedule: "Setiap Rabu · 16.30–18.30",
    price: 50000,
    priceNote: "sketchbook disediakan",
    spotsLeft: 15,
    outletIds: ["tebet"],
  },
];
